<template>
  <CollectionsList type="kpi" :show-files="false" title="KPI Sets" description="A list of all the KPI Sets in your account. You can create multiple KPI Sets, for example, KPI set per Line of Business."></CollectionsList>
</template>
<script setup>
  import CollectionsList from '@/components/Collections/CollectionsList.vue';
</script>
